import { motion, AnimatePresence } from 'framer-motion';
import { forwardRef } from 'react';
import Button from '../../components/ui/Button';

const NotificationPanel = forwardRef(function NotificationPanel({
  isOpen, notifications, filter, setFilter, onRedirect, getNotificationText, getNotificationIcon,
}, ref) {
  const FILTERS = [
    { key: 'all', label: 'Tümü' },
    { key: 'likes', label: 'Beğeniler' },
    { key: 'comments', label: 'Yorumlar' },
    { key: 'other', label: 'Diğer' },
  ];

  const filtered = notifications.filter((n) => {
    if (filter === 'likes') return n.type === 'like';
    if (filter === 'comments') return n.type === 'comment';
    if (filter === 'other') return !['like', 'comment'].includes(n.type);
    return true;
  });

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="notification-panel"
          className="panel notification-panel"
          ref={ref}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.2 }}
        >
          <h3 className="panel-title">Bildirimler</h3>
          <div className="panel-filters">
            {FILTERS.map((f) => (
              <button
                key={f.key}
                className={`panel-filter-btn ${filter === f.key ? 'panel-filter-btn--active' : ''}`}
                onClick={() => setFilter(f.key)}
              >
                {f.label}
              </button>
            ))}
          </div>
          {filtered.length === 0 ? (
            <p className="panel-empty">Henüz bildirimin yok.</p>
          ) : (
            filtered.map((n) => (
              <motion.div
                key={n.id}
                className={`panel-item ${n.read ? '' : 'panel-item--unread'}`}
                onClick={() => onRedirect(n)}
                whileHover={{ background: 'var(--bg-card-hover)' }}
              >
                <span className="panel-item-icon">{getNotificationIcon(n.type)}</span>
                <div className="panel-item-content">
                  <p className="panel-item-text">{getNotificationText(n)}</p>
                  <p className="panel-item-time">{n.timestamp?.toDate?.()?.toLocaleString?.() || ''}</p>
                </div>
              </motion.div>
            ))
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
});

export default NotificationPanel;
